import React, { Component, ReactElement } from "react";

interface Props {
  text: string;
  type: string;
  icon?: ReactElement;
  size?: string;
  className?: string;
  onClick?: (e: any) => void;
}

export default class Button extends Component<Props> {
  render() {
    let defaultSize = "px-5 py-3";
    if (this.props.size === "small") {
      defaultSize = "px-3 py-2";
    }

    let defaultClassName = `block rounded-md border border-transparent font-bold ${defaultSize} text-base font-medium shadow focus:outline-none focus:ring-2 focus:ring-offset-2 sm:px-10`;

    if (this.props.className) {
      defaultClassName += ` ${this.props.className}`;
    }

    if (this.props.type) {
      switch (this.props.type) {
        case "normal":
          defaultClassName +=
            " bg-red-600 text-white hover:bg-red-500 focus:ring-red-600";
          break;
        case "dark":
          defaultClassName +=
            " bg-red-800 text-white hover:bg-red-900 focus:ring-offset-white";
          break;
        case "light":
          defaultClassName +=
            " bg-white text-red-600 hover:bg-gray-100 focus:ring-red-700";
          break;
        case "google":
          defaultClassName +=
            " bg-white border-2 border-gray-200 text-gray-700 hover:bg-gray-100 focus:ring-red-700";
          break;
      }
    }

    return (
      <button
        type="button"
        className={defaultClassName}
        onClick={this.props.onClick}
      >
        <div className="flex flex-row justify-center items-center">
          {this.props.icon ?? null}
          {this.props.text}
        </div>
      </button>
    );
  }
}
